<template>
  <div>
    <!-- 面包屑导航 -->

    <el-card class="box-card">
      <div>
        <el-card class="form-card">
          <el-form ref="form" v-model="form" label-width="80px">
            <el-row>
              <el-col :span="6">
                <el-form-item label="名称">
                  <el-input v-model="form.nameCN"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="路径">
                  <el-input v-model="form.menuRoute"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="备注">
                  <el-input v-model="form.memo"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="创建者">
                  <el-input v-model="form.created_user"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <el-form-item>
                  <el-button @click="dialogFormVisible = true">新增</el-button>
                  <el-button type="primary" @click="onSubmit">搜索</el-button>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row></el-row>
          </el-form>
        </el-card>
      </div>

      <el-table :data="PermList" border stripe style="width: 100%" height="500">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="nameCN" label="名称"></el-table-column>
        <el-table-column prop="name" label="名称(英)"></el-table-column>
        <el-table-column prop="ptnCode" label="商家"></el-table-column>
        <el-table-column prop="shops" label="店铺"></el-table-column>
        <el-table-column prop="menuRoute" label="路径"></el-table-column>
        <el-table-column prop="requestType" label="请求方式"></el-table-column>
        <el-table-column prop="created_user" label="创建者"></el-table-column>
        <el-table-column prop="memo" label="备注"></el-table-column>
        <el-table-column label="操作" width="180" size="small">
          <template slot-scope="scope">
            <!-- 编辑 -->
            <el-tooltip effect="dark" content="编辑" placement="top" :enterable="false">
              <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDilog(scope.row)"></el-button>
            </el-tooltip>

            <!-- 删除 -->
            <el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="delPerm(scope.row.id)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增权限 -->
    <el-dialog title="新增" :visible.sync="dialogFormVisible" width="40%" @close="addDilogClosed" :close-on-click-modal="false">
      <el-form :model="addform" :rules="rules" ref="addformRef" size="mini">
        <el-form-item label="名称(英)" prop="name" :label-width="formLabelWidth">
          <el-input v-model="addform.name" autocomplete="off" style="width: 50%"></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="nameCN" :label-width="formLabelWidth">
          <el-input v-model="addform.nameCN" style="width: 50%"></el-input>
        </el-form-item>

        <template>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="访问权限" name="1">
              <el-row class="row-box">
                <el-form-item label="路径" :label-width="formLabelWidth">
                  <el-input v-model="addform.menuRoute" style="width: 50%"></el-input>
                </el-form-item>

                <el-form-item label="请求方式" :label-width="formLabelWidth">
                  <el-input v-model="addform.requestType" type="textarea" style="width: 50%"></el-input>
                </el-form-item>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="数据权限" name="2">
              <el-row class="row-box">
                <el-form-item label="商家" :label-width="formLabelWidth">
                  <el-select v-model="addform.ptnCode" placeholder="请选择商家" style="width: 50%" @change="changePtn">
                    <el-option v-for="item in PartnerLists" :key="item.id" :label="item.ptnName" :value="item.ptnCode"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="店铺" :label-width="formLabelWidth">
                  <el-select v-model="addform.shops" placeholder="请选择角色" style="width: 50%" multiple>
                    <el-option v-for="item in shopLists" :key="item.id" :label="item.shopName" :value="item.shopCode"></el-option>
                  </el-select>
                </el-form-item>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </template>

        <el-form-item label="备注" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="addform.memo" style="width: 50%"></el-input>
        </el-form-item>

        <el-form-item label="角色" :label-width="formLabelWidth">
          <el-select v-model="addform.roles" placeholder="请选择角色" style="width: 50%">
            <el-option v-for="item in roleList" :key="item.id" :label="item.nameCN" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addPerm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 新增权限 -->
    <el-dialog title="编辑" :visible.sync="editdialogFormVisible" width="40%" @close="addDilogClosed" :close-on-click-modal="false">
      <el-form :model="editform" :rules="rules" ref="addformRef" size="mini">
        <el-form-item label="名称(英)" prop="name" :label-width="formLabelWidth">
          <el-input v-model="editform.name" autocomplete="off" style="width: 50%"></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="nameCN" :label-width="formLabelWidth">
          <el-input v-model="editform.nameCN" style="width: 50%"></el-input>
        </el-form-item>

        <template>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="访问权限" name="1">
              <el-row class="row-box">
                <el-form-item label="路径" :label-width="formLabelWidth">
                  <el-input v-model="editform.menuRoute" style="width: 50%"></el-input>
                </el-form-item>

                <el-form-item label="请求方式" :label-width="formLabelWidth">
                  <el-input v-model="editform.requestType" type="textarea" style="width: 50%"></el-input>
                </el-form-item>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="数据权限" name="2">
              <el-row class="row-box">
                <el-form-item label="商家" :label-width="formLabelWidth">
                  <el-select v-model="editform.ptnCode" placeholder="请选择商家" style="width: 50%" @change="changePtn">
                    <el-option v-for="item in PartnerLists" :key="item.id" :label="item.ptnName" :value="item.ptnCode"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="店铺" :label-width="formLabelWidth">
                  <el-select v-model="editform.shops" placeholder="请选择角色" style="width: 50%" multiple>
                    <el-option v-for="item in shopLists" :key="item.id" :label="item.shopName" :value="item.shopCode"></el-option>
                  </el-select>
                </el-form-item>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </template>

        <el-form-item label="备注" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="editform.memo" style="width: 50%"></el-input>
        </el-form-item>

        <el-form-item label="角色" :label-width="formLabelWidth">
          <el-select v-model="editform.roles" placeholder="请选择角色" style="width: 50%">
            <el-option v-for="item in roleList" :key="item.id" :value="item.id" :label="item.nameCN"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="editdialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveEditPerm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>



<script>
export default {
  data() {
    // 验证邮箱规则
    var checkEmail = (rule, value, callback) => {
      // 正则表达式
      const regEmail = /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z_-])+/;
      if (regEmail.test(value)) {
        return callback();
      }
      callback(new Error("请输入合法的邮箱"));
    };
    // 验证手机号规则
    var checkMobile = (rule, value, callback) => {
      const regMobile = /^(13[0-9]|15[012356789]|15[012356789]|17[5678]|18[0-9]|19[0-9]|14[57])[0-9]{8}$/;
      // 符合规则
      if (regMobile.test(value)) {
        return callback();
      }
      callback(new Error("请输入合法的手机号"));
    };

    return {
      form: {
        name: "",
        nameCN: "",
        ptnCode: "",
        shops: "",
        requestType: "",
        roles: "",
        memo: "",
        created_user: "",
        type: "",
      },
      addform: {
        name: "",
        nameCN: "",
        ptnCode: "",
        shops: "",
        requestType: "",
        roles: "",
        memo: "",
        type: "",
      },
      editform: {
        name: "",
        nameCN: "",
        ptnCode: "",
        shops: "",
        requestType: "",
        roles: "",
        memo: "",
        type: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入权限名称", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "长度在 3 到 20 个字符",
            trigger: "blur",
          },
        ],
        guard_name: [
          { required: true, message: "请输入名称(英)", trigger: "blur" },
        ],
      },

      total: 0,
      PermList: [],
      PartnerLists: [],
      roleList: [],
      shopLists: [],
      queryInfo: {
        query: "",
        pagenum: 1,
        pagesize: 10,
      },
      currentPage: 1,
      bdialogFormVisible: false,
      dialogFormVisible: false,
      editdialogFormVisible: false,
      formLabelWidth: "100px",
      errmsg: "",
      activeName: "1",
    };
  },
  methods: {
    onSubmit() {
      console.log("submit!");
    },

    handleSizeChange(val) {
      this.queryInfo.pagesize = val;
      console.log(`每页 ${val} 条`);
      this.getUserList();
    },
    handleCurrentChange(val) {
      this.queryInfo.pagenum = val;
      console.log(`当前页: ${val}`);
      this.getUserList();
    },

    handleClick(tab, event) {
      console.log(tab.paneName);
      this.addform.type = tab.paneName;
    },
    async getPermissions() {
      await this.$http
        .post("Permissions", this.queryInfo)
        .then((response) => {
          const res = response.data;

          this.PermList = res.data;

          this.total = 0;

          this.currentPage = res.current_page;
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message);
        });
    },
    // 获取角色列表
    async getRoleLists() {
      await this.$http
        .post("rolelists", {
          query: "",
          pagenum: 1,
          pagesize: 100,
        })
        .then((response) => {
          const res = response.data;
          this.roleList = res.data;
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message);
        });
    },

    // 删除权限
    async delPerm(userid) {
      // 弹框询问是否删除
      const confirmResult = await this.$confirm(
        "此操作将永久删除该权限, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);

      // 确认删除
      if (confirmResult == "confirm") {
        await this.$http
          .delete("delPerm/" + userid)
          .then((response) => {
            this.$message.success("删除成功");

            this.currentPage = 1;

            this.getPermissions();
          })
          .catch((error) => {
            return this.$message.error(error.response.data.message);
          });
      }
    },
    addDilogClosed() {
      this.$refs.addformRef.resetFields();
    },
    editDilogClosed() {
      this.$refs.editformRef.resetFields();
    },
    bDilogClosed() {
      this.$refs.editformRef.resetFields();
    },

    // 新增权限
    async addPerm() {
      this.$refs.addformRef.validate(async (valid) => {
        if (!valid) return;

        await this.$http
          .post("addPerm", this.addform)
          .then((response) => {
            this.$message.success("新增成功");
            this.dialogFormVisible = false;
            this.getPermissions();
          })
          .catch((error) => {
            return this.$message.error(error.response.data.message);
          });
      });
    },

    // 编辑权限
    async saveEditPerm() {
      this.$refs.addformRef.validate(async (valid) => {
        if (!valid) return;

        await this.$http
          .post("editPerm", this.editform)
          .then((response) => {
            this.$message.success("修改成功");
            this.editdialogFormVisible = false;
            this.getPermissions();
          })
          .catch((error) => {
            return this.$message.error(error.response.data.message);
          });
      });
    },

    // 获取商家列表
    async getPartnerLists() {
      const { data: res } = await this.$http.post("ptnlists", {
        query: "",
        pagenum: 1,
        pagesize: 100,
      });

      if (res.meta.status !== 200)
        return this.$message.error("获取商家列表失败");
      this.PartnerLists = res.data.data;
    },
    // 商家变更
    async changePtn(cb) {
      await this.$http
        .post("shoplists", { ptnCode: cb })
        .then((response) => {
          const res = response.data;
          this.shopLists = res.data.data;
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message);
        });
    },
    // 显示修改
    async showEditDilog(row) {
      let copy = Object.assign({}, row);
      this.editform = copy;
      this.editdialogFormVisible = true;
    },
    // 显示修改用户对话框
    async showAddBlack(row) {
      this.editform = row;
      this.bdialogFormVisible = true;
    },
  },
  created() {
    this.getPermissions();
    this.getPartnerLists();
    this.getRoleLists();
  },
};
</script>

<style lang="less" scoped>
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.form-card {
  margin-bottom: 15px;
}
.el-dialog {
  /* 表单页面居中，宽度50% ,legend颜色设置，legend圆角*/
  border: 2px solid #dcdfe6;
  text-align: center;
  border-radius: 8px;
  margin: 0 auto;
  width: 50%;
}
.row-box {
  margin: 10px 0;
  padding: 12px;
  border-radius: 15px;
  border: 1px dashed#77a2cf;
}
.row-box-group {
  border: 1px dashed #cf7777;
}
</style>



// WEBPACK FOOTER //
// src/views/sys/perm/index.vue